import { Product } from "@shopify/hydrogen-react/storefront-api-types"

export const isGiftBundle = (product: Product | GatsbyTypes.SanityProduct) =>
  product?.tags?.some(tag => tag === "giftBundle" || tag?.includes("giftBundle:") || false)
